import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
} from "redux/helpers/fetching"
import { fetchSubscriptionEligibility } from "redux/features/subscription_eligibility/subscriptionEligibilityThunk"

const subscriptionEligibilityAdapter = createEntityAdapter()
export const initialState = subscriptionEligibilityAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const subscriptionEligibilitySlice = createSlice({
  name: "subscription-eligibility",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchSubscriptionEligibility.pending, (state) =>
        handleFetchPending(state),
      )
      .addCase(fetchSubscriptionEligibility.rejected, (state) =>
        handleFetchRejected(state),
      )
      .addCase(fetchSubscriptionEligibility.fulfilled, (state, { payload }) => {
        subscriptionEligibilityAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
  },
})

export const { selectById: selectSubscriptionEligibilityById } =
  subscriptionEligibilityAdapter.getSelectors(
    (state: RootState) => state.features.subscription_eligibility,
  )
export const selectFetchStatus = (state: RootState) =>
  state.features.subscription_eligibility.fetchStatus

export default subscriptionEligibilitySlice.reducer
